export default __webpack_public_path__ + "static/pineapple_advenure_1-a29c9d647c040177e2c0ef7f7a827d08.png";